import { NetworkStatus } from '@apollo/client';
import { useDataSyncApps } from './useDataSyncApps';
import { getReconnectionConfig } from '../utils/getReconnectionConfig';
import { useDashworksAppIds } from './useDashworksAppIds';
import { useMcpSupportedApps } from './useMcpSupportedApps';
import { useUnifiedAccountSupportedApps } from './useUnifiedAccountSupportedApps';
const OAUTHOR_MIGRATION_ORIGIN = 'OAUTHOR';
export const useServiceComponent = ({
  metadata,
  url,
  reconnectionConfig: reconnectionConfigProp
}) => {
  const appId = (metadata === null || metadata === void 0 ? void 0 : metadata.appId) || 0;
  const status = metadata === null || metadata === void 0 ? void 0 : metadata.status;
  const {
    data: unifiedAccountApps,
    loading: unifiedAccountAppsLoading,
    error: unifiedAccountAppsError,
    networkStatus: unifiedAccountAppsNetworkStatus
  } = useUnifiedAccountSupportedApps({
    skip: !!reconnectionConfigProp
  });
  const {
    data: dataSyncApps,
    isLoading: dataSyncAppsLoading,
    error: dataSyncAppsError,
    networkStatus: dataSyncAppsNetworkStatus
  } = useDataSyncApps({
    skip: !!reconnectionConfigProp
  });
  const {
    data: dashworksAppIds,
    isLoading: dashworksAppIdsLoading,
    error: dashworksAppIdsError,
    networkStatus: dashworksAppsNetworkStatus
  } = useDashworksAppIds({
    skip: !!reconnectionConfigProp
  });
  const {
    data: mcpServers,
    loading: mcpServersLoading,
    error: mcpServersError,
    networkStatus: mcpServersNetworkStatus
  } = useMcpSupportedApps({
    skip: !!reconnectionConfigProp
  });
  const isDataLoaded = dataSyncAppsNetworkStatus >= NetworkStatus.ready && dashworksAppsNetworkStatus >= NetworkStatus.ready && unifiedAccountAppsNetworkStatus >= NetworkStatus.ready && mcpServersNetworkStatus >= NetworkStatus.ready;
  const error = dataSyncAppsError || dashworksAppIdsError || unifiedAccountAppsError || mcpServersError;
  const unifiedAccountApp = unifiedAccountApps.find(({
    appId: unifiedAccountAppId
  }) => unifiedAccountAppId === appId);
  const isUnifiedAccountSupportedApp = !!unifiedAccountApp;
  const isUnifiedAccountMigration = (unifiedAccountApp === null || unifiedAccountApp === void 0 ? void 0 : unifiedAccountApp.migrationOrigin) === OAUTHOR_MIGRATION_ORIGIN;
  const isDataSyncApp = dataSyncApps.some(({
    appId: dataSyncAppId
  }) => dataSyncAppId === appId);
  const isDashworksApp = dashworksAppIds.some(dashworkAppId => dashworkAppId === appId);
  const isMcpSupportedApp = mcpServers.some(({
    mcpAppId
  }) => mcpAppId === appId);
  let reconnectionConfig = reconnectionConfigProp !== null && reconnectionConfigProp !== void 0 ? reconnectionConfigProp : null;
  if (!reconnectionConfig && isDataLoaded && !error) {
    reconnectionConfig = getReconnectionConfig({
      appId,
      isDataSyncApp,
      isDashworksApp,
      isMcpSupportedApp,
      isUnifiedAccountSupportedApp,
      hasUrl: !!url
    });
  }
  const {
    statusesForDisplaying,
    serviceComponent: ServiceComponent = null
  } = reconnectionConfig || {};
  const isVisible = !(statusesForDisplaying !== null && statusesForDisplaying !== void 0 && statusesForDisplaying.length) || statusesForDisplaying.includes(status);
  return {
    serviceComponent: isVisible ? ServiceComponent : null,
    loading: dataSyncAppsLoading || dashworksAppIdsLoading || unifiedAccountAppsLoading || mcpServersLoading,
    error,
    isLoaded: isDataLoaded,
    isUnifiedAccountMigration
  };
};